import { useEffect } from 'react';

// The old standalone form is retired. The main CKW application owns reservations,
// referral claims, invoice discounts and the staff gift queue.
const CANONICAL_URL = 'https://chefknifeworks.com/refer';

function destination() {
  const code = new URLSearchParams(window.location.search).get('ref')?.trim().toUpperCase() || '';
  if (/^[23456789ABCDEFGHJKLMNPQRSTUVWXYZ]{6,12}$/.test(code)) {
    return `${CANONICAL_URL}?ref=${encodeURIComponent(code)}`;
  }
  return CANONICAL_URL;
}

export default function App() {
  const target = destination();

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <main className="gateway">
      <div className="gateway-card">
        <p className="gateway-eyebrow">CHEF KNIFEWORKS · MAPLE GROVE</p>
        <p className="gateway-monogram" aria-hidden="true">CKW</p>
        <h1>Edge Perks has a sharper home.</h1>
        <p className="gateway-description">
          Give a new customer 10% off their first qualifying $50+ sharpening
          order (up to $10). When that order is paid, earn a $10 coffee e-gift.
        </p>
        <a className="gateway-button" href={target}>
          Continue to Edge Perks <span aria-hidden="true">→</span>
        </a>
        <p className="gateway-note">
          Referral links and rewards are now managed securely by Chef KnifeWorks.
          We never ask you to provide a friend's contact information.
        </p>
        <p className="gateway-tagline">Feel the Difference Sharp Can Make.</p>
      </div>
    </main>
  );
}
